import React from 'react';

import { observer } from 'mobx-react';
import { linearModel } from 'mobx-store';

import { SCATTER_PLOT_TYPES } from 'mobx-store/linearModel';

import BoxPlot from './BoxPlot';
import ScatterPlot from './ScatterPlot';
import RightPaneComponent from './Component';

const RightPaneContainer = observer(
  () => {
    const isNumericalCategorical = linearModel.performAnovaTest;

    const renderMainScatterPlotOrBoxPlot = () =>
      isNumericalCategorical
        ? <BoxPlot />
        : <ScatterPlot type={SCATTER_PLOT_TYPES.MAIN} />;

    const renderResidualsScatterPlot = () => <ScatterPlot type={SCATTER_PLOT_TYPES.RESIDUALS} />;

    const renderProbabilityScatterPlot = () => <ScatterPlot type={SCATTER_PLOT_TYPES.NORMAL} />;

    return (
      <RightPaneComponent
        isNumericalCategorical={isNumericalCategorical}
        renderResidualsScatterPlot={renderResidualsScatterPlot}
        renderProbabilityScatterPlot={renderProbabilityScatterPlot}
        renderMainScatterPlotOrBoxPlot={renderMainScatterPlotOrBoxPlot}
      />
    );
  }
);

export default RightPaneContainer;
